
export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-[#0D0E11] to-[#061B3A] border-t border-[#29A5FF]/20 pt-8 sm:pt-10 md:pt-12 pb-4 sm:pb-5 md:pb-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-5 md:px-6 lg:px-12">
        {/* Footer Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 md:gap-8 mb-6 sm:mb-8 md:mb-10">
          {/* Company */}
          <div>
            <h4 className="text-white font-bold text-sm sm:text-base md:text-lg mb-2 sm:mb-3 md:mb-4" style={{ fontFamily: 'Orbitron, sans-serif' }}>
              Company
            </h4>
            <ul className="space-y-1 sm:space-y-1.5 md:space-y-2">
              <li>
                <a href="#about" className="text-white/70 hover:text-[#EFBF65] transition-colors duration-300 text-xs sm:text-sm cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  About <span className="notranslate">DigitWise</span>
                </a>
              </li>
              <li>
                <a href="#licensing" className="text-white/70 hover:text-[#EFBF65] transition-colors duration-300 text-xs sm:text-sm cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Licensing
                </a>
              </li>
              <li>
                <a href="#partnership" className="text-white/70 hover:text-[#EFBF65] transition-colors duration-300 text-xs sm:text-sm cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Partnership
                </a>
              </li>
              <li>
                <a href="#responsible" className="text-white/70 hover:text-[#EFBF65] transition-colors duration-300 text-xs sm:text-sm cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Responsible Gaming
                </a>
              </li>
            </ul>
          </div>

          {/* Help */}
          <div>
            <h4 className="text-white font-bold text-sm sm:text-base md:text-lg mb-2 sm:mb-3 md:mb-4" style={{ fontFamily: 'Orbitron, sans-serif' }}>
              Help
            </h4>
            <ul className="space-y-1 sm:space-y-1.5 md:space-y-2">
              <li>
                <a href="#faq" className="text-white/70 hover:text-[#EFBF65] transition-colors duration-300 text-xs sm:text-sm cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  FAQ
                </a>
              </li>
              <li>
                <a href="#support" className="text-white/70 hover:text-[#EFBF65] transition-colors duration-300 text-xs sm:text-sm cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Live Support
                </a>
              </li>
              <li>
                <a href="#mobile" className="text-white/70 hover:text-[#EFBF65] transition-colors duration-300 text-xs sm:text-sm cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Mobile App Download
                </a>
              </li>
            </ul>
          </div>

          {/* Providers */}
          <div>
            <h4 className="text-white font-bold text-sm sm:text-base md:text-lg mb-2 sm:mb-3 md:mb-4" style={{ fontFamily: 'Orbitron, sans-serif' }}>
              Providers
            </h4>
            <ul className="space-y-1 sm:space-y-1.5 md:space-y-2">
              <li>
                <a href="#pragmatic" className="text-white/70 hover:text-[#EFBF65] transition-colors duration-300 text-xs sm:text-sm cursor-pointer notranslate" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Pragmatic Play
                </a>
              </li>
              <li>
                <a href="#pgsoft" className="text-white/70 hover:text-[#EFBF65] transition-colors duration-300 text-xs sm:text-sm cursor-pointer notranslate" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  PG SOFT
                </a>
              </li>
              <li>
                <a href="#cq9" className="text-white/70 hover:text-[#EFBF65] transition-colors duration-300 text-xs sm:text-sm cursor-pointer notranslate" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  CQ9 Gaming
                </a>
              </li>
              <li>
                <a href="#playgo" className="text-white/70 hover:text-[#EFBF65] transition-colors duration-300 text-xs sm:text-sm cursor-pointer notranslate" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Play'n GO
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-bold text-sm sm:text-base md:text-lg mb-2 sm:mb-3 md:mb-4" style={{ fontFamily: 'Orbitron, sans-serif' }}>
              Legal
            </h4>
            <ul className="space-y-1 sm:space-y-1.5 md:space-y-2">
              <li>
                <a href="#terms" className="text-white/70 hover:text-[#EFBF65] transition-colors duration-300 text-xs sm:text-sm cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Terms & Conditions
                </a>
              </li>
              <li>
                <a href="#privacy" className="text-white/70 hover:text-[#EFBF65] transition-colors duration-300 text-xs sm:text-sm cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#cookies" className="text-white/70 hover:text-[#EFBF65] transition-colors duration-300 text-xs sm:text-sm cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-4 sm:pt-5 md:pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2 sm:gap-3 md:gap-4">
            {/* Copyright */}
            <p className="text-white/60 text-[10px] sm:text-xs md:text-sm text-center md:text-left" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              © 2019 <span className="notranslate">DigitWise</span> Entertainment Holdings. All Rights Reserved.
            </p>

            {/* Readdy Link */}
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/60 hover:text-[#EFBF65] text-[10px] sm:text-xs md:text-sm transition-colors duration-300 cursor-pointer notranslate"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
